module.exports = __webpack_public_path__ + "img/rob.f75c2a93.svg";